import { render, staticRenderFns } from "./CdlSaudeArquivos.vue?vue&type=template&id=e6592e08&scoped=true&"
import script from "./CdlSaudeArquivos.vue?vue&type=script&lang=js&"
export * from "./CdlSaudeArquivos.vue?vue&type=script&lang=js&"
import style0 from "./CdlSaudeArquivos.vue?vue&type=style&index=0&id=e6592e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6592e08",
  null
  
)

export default component.exports